<!--
    课程分销数据
    功能：课程分销数据
    说明：旧版本
-->
<template>
  <div class="role">
    <!-- :create-label="'新增'"
    @create="addCreate" -->
    <AppList
      ref="list"
      :list.sync="list"
      title=""
      :api="api"
      >
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            fixed="right"
            label="操作"
            :width="`${$store.state.from === 'schoolCenter' ? 210 : 300}px`"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <template v-if="$store.state.from === 'schoolCenter'">
                <el-link
                  @click="editSee(scope.row.id)"
                >查看</el-link>
                <i class="icon-splite">|</i>
                <el-link
                  @click="editLink(scope.row.id, 'buyStatistics')"
                >购买统计</el-link>
                <i class="icon-splite">|</i>
                <el-link
                  @click="editLink(scope.row.id, 'timeStatistics')"
                >耗课统计</el-link>
              </template>
              <template v-else>
                <!-- <div style="white-space: nowrap;"> -->
                <!-- <el-button class="opt-btn" size="small" @click="editShelf(scope.row.id, scope.row.status == 1 ? 2 : 1)">{{scope.row.status_text === '上架' ? '下架' : '上架'}}</el-button> -->
                <el-button class="opt-btn" size="small" @click="editSee(scope.row.id)">查看</el-button>
                <!-- <el-button class="opt-btn" size="small" @click="editUpdate(scope.row.id)">编辑</el-button> -->
                <!-- <el-button class="opt-btn" size="small" @click="editDelete(scope.row.id)">删除</el-button> -->
              <!-- </div> -->
              <!-- <div style="white-space: nowrap;"> -->
                <!-- <el-button class="opt-btn" size="small" @click="editClass(scope.row)">课时编辑</el-button> -->

                <el-button class="opt-btn" size="small" @click="editLink(scope.row.id, 'buyStatistics')">购买统计</el-button>
                <el-button class="opt-btn" size="small" @click="editLink(scope.row.id, 'timeStatistics')">耗课统计</el-button>
              <!-- </div> -->
              </template>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>

    <el-dialog
      :title="formData.title"
      :visible.sync="formDialogVisible"
      width="1000px"
    >
      <el-form
        :rules="rules"
        ref="form"
        v-loading.lock="formLoading"
        :model="formData"
        label-width="150px"
        :disabled="formData.title === '查看详情'"
        :class="{'dis-event': formData.title === '查看详情'}"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="*商品封面图" class="headimgurl">
              <AppUploadScale
                v-model="formData.cover"
                class="form_img"
                :common="true"
                :icon="true"
                @on-success="getCoverUrl"/>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="商品视频介绍" class="headimgurl">
              <AppUploadVideo
                v-model="formData.video"
                class="form_img"
                :common="true"
                :icon="true"
                @on-success="getVideoUrl"/>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="商品视频介绍链接" prop="video">
              <el-input v-model="formData.video" placeholder="链接" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="商品名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="商品简介" prop="introduction">
          <el-input :autosize="{ minRows: 2, maxRows: 20}" v-model="formData.introduction" type="textarea"></el-input>
        </el-form-item>
        <el-form-item
          label="商品详情"
          prop="detail"
          class="area-detail">
          <AppTextArea
            :value="formData.detail"
            :init-visible="formDialogVisible"
            :is-disable="false"
            @change="changeFn"
          />
        </el-form-item>

        <el-form-item label="商品类别" prop="commodity_tag_id">
          <el-select v-model="formData.commodity_tag_id" placeholder="请选择">
            <el-option
              v-for="state in commodity_tag_list"
              :key="state.id"
              :label="state.name"
              :value="state.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="所属类别" prop="stage_tag_id">
          <el-select v-model="formData.stage_tag_id" placeholder="请选择">
            <el-option
              v-for="state in stage_tag_list"
              :key="state.id"
              :label="state.name"
              :value="state.id"
            />
          </el-select>
          <el-select v-model="formData.subject_tag_id" placeholder="请选择">
            <el-option
              v-for="state in subject_tag_list"
              :key="state.id"
              :label="state.name"
              :value="state.id"
            />
          </el-select>
        </el-form-item>

        <el-row type="flex">
          <el-form-item label="开放校区" prop="">
            <el-select multiple v-model="formData.school_ids" placeholder="请选择">
              <el-option
                v-for="state in school_list"
                :key="state.value"
                :label="state.name"
                :value="state.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="制作校区" prop="">
            <el-input v-model="school_list_make"></el-input>
          </el-form-item>
        </el-row>

        <el-form-item label="线下课时单价（/课时/次）" prop="">
          <el-row type="flex">
            <el-form-item type="flex" style="white-space: nowrap;">
              原价
              <el-input v-model="formData.offline_price"></el-input>
              金币
            </el-form-item>
            <el-form-item type="flex" style="white-space: nowrap;" label="优惠价">
              <el-input v-model="formData.offline_discount_price"></el-input>
              金币
            </el-form-item>
          </el-row>
        </el-form-item>

        <el-form-item label="线上课时单价（/课时/学生/次）" prop="">
          <el-row type="flex">
            <el-form-item type="flex" style="white-space: nowrap;">
              原价
              <el-input v-model="formData.online_price"></el-input>
              金币
            </el-form-item>
            <el-form-item type="flex" style="white-space: nowrap;" label="优惠价">
              <el-input v-model="formData.online_discount_price"></el-input>
              金币
            </el-form-item>
          </el-row>
        </el-form-item>

        <el-radio-group v-model="formData.status">
          <el-radio :label="1">立即上架</el-radio>
          <el-radio :label="2">手动上架</el-radio>
        </el-radio-group>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <template v-if="formData.title === '查看详情'">
          <el-button type="primary" @click="formDialogVisible = false">确 定</el-button>
        </template>
        <template v-else>
          <el-button @click="formDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addSubmit">确 定</el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import index from './';
  export default index;
</script>

<style scoped lang="scss">
  @import '../../assets/reset.scss';
  @import "index.scss"
</style>



// WEBPACK FOOTER //
// src/views/CourseDistribution/index.vue